export const tvMazeBaseURL = "https://api.tvmaze.com/";
export const redditBaseURL = "https://www.reddit.com/";
export const redditBaseURLNoForwardSlash = "https://www.reddit.com";

// CORS proxy for Reddit API requests (development only)
// For production, you should set up your own backend proxy
export const corsProxy = "https://corsproxy.io/?";
export const redditApiURL = `${corsProxy}${encodeURIComponent(redditBaseURL)}`;
